module.exports = "https://cdn.nebula.starbreeze.com/legal/static/media/ufo.5a5a8de0.png";